import React from 'react';
import { Link } from 'react-router-dom';
import { GithubIcon, LinkedinIcon, MailIcon, ExternalLinkIcon, ArrowRightIcon } from 'lucide-react';
import Journey from '../Components/journey/journey.component';
import ContactMe from '../Components/contact-me/contactme.component';

function Home() {
  return (
    <div className="min-h-screen bg-white text-gray-900">
      <main className="container py-20">
        <section className="text-center mb-20">
          <h1 className="text-5xl sm:text-6xl font-bold tracking-tight mb-4">Sourav</h1>
          <p className="text-lg text-gray-600 max-w-xl mx-auto mb-8">
            Backend engineer who builds distributed, event-driven systems — currently in fintech,
            with a growing focus on AI-native retrieval and agentic systems.
          </p>
          <div className="flex items-center justify-center gap-5 flex-wrap">
            <a
              href="https://github.com/sourav15102"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-1.5 text-sm text-gray-700 hover:text-black hover:underline"
            >
              <GithubIcon className="w-4 h-4" /> GitHub
            </a>
            <a
              href="https://www.linkedin.com/in/sghai96"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-1.5 text-sm text-gray-700 hover:text-black hover:underline"
            >
              <LinkedinIcon className="w-4 h-4" /> LinkedIn
            </a>
            <a
              href="mailto:souravghai96@gmail.com"
              className="flex items-center gap-1.5 text-sm text-gray-700 hover:text-black hover:underline"
            >
              <MailIcon className="w-4 h-4" /> Email
            </a>
            <a
              href="/Sourav_6yoe_Resume.pdf"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-1.5 text-sm rounded-md border border-gray-300 px-3 py-1.5 hover:bg-gray-50"
            >
              Resume <ExternalLinkIcon className="w-3.5 h-3.5" />
            </a>
          </div>
        </section>

        <section className="mb-20">
          <Link
            to="/now"
            className="flex items-center justify-between rounded-lg border border-gray-200 px-6 py-5 hover:bg-gray-50 transition-colors"
          >
            <div>
              <h2 className="text-sm font-semibold uppercase tracking-wide text-gray-500 mb-1">
                What I'm working on
              </h2>
              <p className="text-gray-800">
                Anti-fraud infrastructure at Nasdaq Verafin, and a code search retrieval pipeline.
              </p>
            </div>
            <ArrowRightIcon className="w-5 h-5 text-gray-400 shrink-0 ml-4" />
          </Link>
        </section>

        <Journey />
      </main>

      <ContactMe />
    </div>
  );
}

export default Home;
